import { render } from "./Invoice.vue?vue&type=template&id=6af7d9dd&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=6af7d9dd&lang=css"
import "./Invoice.vue?vue&type=style&index=1&id=6af7d9dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af7d9dd"]])

export default __exports__